import { StrategyMapView } from "../../features/StrategyMapView/StrategyMapView";
import { Page } from "../../shared/atoms/Page";

export function StrategyMapsViewPage() {
    return (
        <Page>
          <StrategyMapView/>
        </Page>
    )   
}